"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _preactCompat = require("preact-compat");

var _ImageLightbox = require("@insided/shared/components/ImageLightbox");

var _globals = require("@insided/shared/utils/globals");

var _cdnImage = require("@insided/shared/utils/cdnImage");

var _experimentalSettings = require("@insided/shared/services/experimental-settings");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CONTENT_IMAGE_RESIZE_FLAG = 'contentImageResize';
var cssAnchorName = 'common-content';
exports.cssAnchorName = cssAnchorName;
var CONTENT_IMAGE_SIZES = '(min-width: 1024px) 720px, (min-width: 768px) 80vw, 100vw';
var IMG_TAG_PATTERN = /<img\b([^>]*)>/gi;

var buildAttributePresencePattern = function buildAttributePresencePattern(name) {
  return new RegExp("\\b".concat(name, "\\s*="), 'i');
};

var buildAttributeValuePattern = function buildAttributeValuePattern(name) {
  return new RegExp("\\b".concat(name, "\\s*=\\s*(?:\"([^\"]*)\"|'([^']*)'|([^\\s>]+))"), 'i');
};

var readAttributeValue = function readAttributeValue(attrs, name) {
  var _ref, _ref2, _match$;

  var match = attrs.match(buildAttributeValuePattern(name));

  if (match === null) {
    return null;
  }

  return (_ref = (_ref2 = (_match$ = match[1]) !== null && _match$ !== void 0 ? _match$ : match[2]) !== null && _ref2 !== void 0 ? _ref2 : match[3]) !== null && _ref !== void 0 ? _ref : '';
};

var hasAttribute = function hasAttribute(attrs, name) {
  return buildAttributePresencePattern(name).test(attrs);
};
/**
 * Escapes a value for safe injection inside a double-quoted HTML
 * attribute. CDN URLs from `buildCdnSrcSet` don't currently contain `"`
 * or `&`, but escaping defensively keeps the rewrite robust if the
 * upstream URL builder ever changes.
 */


var escapeAttributeValue = function escapeAttributeValue(value) {
  return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
};

/**
 * Rewrites `<img>` tags in post HTML to inject native lazy-loading and a
 * CDN-resized `srcset`/`sizes`, so the browser fetches a smaller variant
 * instead of the original upload.
 * `src` is left untouched so the lightbox still opens the full-resolution
 * image. Author-supplied attributes always win over injected defaults.
 */
var rewriteContentImages = function rewriteContentImages(html) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!html.includes('<img')) {
    return html;
  }

  var renderImagesAsLazy = options.renderImagesAsLazy !== false;
  return html.replace(IMG_TAG_PATTERN, function (fullTag, rawAttrs) {
    var src = readAttributeValue(rawAttrs, 'src');

    if (src === null || src.includes('emojione')) {
      return fullTag;
    }

    var additions = [];

    if (renderImagesAsLazy) {
      if (!hasAttribute(rawAttrs, 'loading')) {
        additions.push('loading="lazy"');
      }

      if (!hasAttribute(rawAttrs, 'decoding')) {
        additions.push('decoding="async"');
      }
    }

    if (!hasAttribute(rawAttrs, 'srcset') && (0, _cdnImage.isResizableCdnUrl)(src)) {
      var srcset = (0, _cdnImage.buildCdnSrcSet)(src, _cdnImage.DEFAULT_WIDTHS);

      if (srcset !== '') {
        additions.push("srcset=\"".concat(escapeAttributeValue(srcset), "\""));

        if (!hasAttribute(rawAttrs, 'sizes')) {
          additions.push("sizes=\"".concat(escapeAttributeValue(CONTENT_IMAGE_SIZES), "\""));
        }
      }
    }

    if (additions.length === 0) {
      return fullTag;
    }
    /**
     * Preserve the XHTML-style trailing slash (`<img … />`) when the
     * editor emits it. We strip it before appending new attributes and
     * re-attach it at the end so the resulting tag still self-closes.
     *
     * `String.prototype.trimEnd()` is used instead of `.replace(/\s+$/, '')`:
     * the regex has worst-case quadratic backtracking on inputs like
     * `<img …                 x>` (long internal whitespace run with
     * non-whitespace before the closing `>`), which a malicious post
     * could engineer to stall the SSR worker. `trimEnd` is a linear
     * scan from the end of the string with no backtracking.
     */


    var trimmed = rawAttrs.trimEnd();
    var selfClosing = trimmed.endsWith('/');
    var attrsWithoutSlash = selfClosing ? trimmed.slice(0, -1).trimEnd() : trimmed;
    return "<img".concat(attrsWithoutSlash, " ").concat(additions.join(' ')).concat(selfClosing ? ' /' : '', ">");
  });
};

var Content = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Content, _PureComponent);

  var _super = _createSuper(Content);

  function Content() {
    var _this;

    (0, _classCallCheck2.default)(this, Content);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "element", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cachedRawContent", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cachedRenderImagesAsLazy", true);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cachedProcessedContent", '');
    return _this;
  }

  (0, _createClass2.default)(Content, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderSubComponents();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderSubComponents();
    }
  }, {
    key: "renderSubComponents",
    value: function renderSubComponents() {
      if (this.element) {
        window.insided.bindPreactComponents(this.element); // Bind modern Preact lightbox to images in this content

        _ImageLightbox.ImageLightbox.bindTo(this.element);
      }
    }
  }, {
    key: "getProcessedContent",
    value: function getProcessedContent(activeModules) {
      var _this$props = this.props,
          content = _this$props.content,
          _this$props$renderIma = _this$props.renderImagesAsLazy,
          renderImagesAsLazy = _this$props$renderIma === void 0 ? true : _this$props$renderIma;

      if (!activeModules.includes(CONTENT_IMAGE_RESIZE_FLAG) || !_experimentalSettings.experimental.has(CONTENT_IMAGE_RESIZE_FLAG)) {
        return content;
      }

      if (this.cachedRawContent === content && this.cachedRenderImagesAsLazy === renderImagesAsLazy) {
        return this.cachedProcessedContent;
      }

      var processed = rewriteContentImages(content, {
        renderImagesAsLazy: renderImagesAsLazy
      });
      this.cachedRawContent = content;
      this.cachedRenderImagesAsLazy = renderImagesAsLazy;
      this.cachedProcessedContent = processed;
      return processed;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          isControl = _this$props2.isControl;
      return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (activeModules) {
        return (0, _preact.h)("div", {
          ref: function ref(element) {
            _this2.element = element;
          },
          className: (0, _classnames.default)(className, 'post__content', 'post__content--new-editor', {
            'post__content--control': isControl
          }),
          dangerouslySetInnerHTML: {
            __html: _this2.getProcessedContent(activeModules)
          }
        });
      });
    }
  }]);
  return Content;
}(_preactCompat.PureComponent);

var _default = Content;
exports.default = _default;